import { render, staticRenderFns } from "./Attacking.vue?vue&type=template&id=05c7a2dd&scoped=true&"
import script from "./Attacking.vue?vue&type=script&lang=js&"
export * from "./Attacking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c7a2dd",
  null
  
)

export default component.exports